var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path13, _path14, _path15, _rect7, _rect8, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCollor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 814.38 295.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:-.01em;}.cls-2{letter-spacing:-.02em;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#c70471;}.cls-5{letter-spacing:-.01em;}.cls-6{letter-spacing:-.02em;}.cls-7{letter-spacing:-.03em;}.cls-8{font-family:Montserrat-Regular, Montserrat;font-size:15px;}.cls-9{letter-spacing:-.02em;}.cls-10{letter-spacing:-.01em;}.cls-11{letter-spacing:0em;}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:url(#linear-gradient-2);}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-5);}.cls-20{letter-spacing:0em;}.cls-21{letter-spacing:0em;}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-13);}.cls-27{fill:url(#linear-gradient-12);}.cls-28{fill:url(#linear-gradient-10);}.cls-29{fill:url(#linear-gradient-11);}.cls-30{letter-spacing:0em;}.cls-31{letter-spacing:-.03em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 100.72,
    y1: 139.28,
    x2: 165.85,
    y2: 139.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#210294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c70471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 168.72,
    y1: 149.54,
    x2: 209.03,
    y2: 149.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 216.52,
    y1: 139.28,
    x2: 282.78,
    y2: 139.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 289.55,
    y1: 139.28,
    x2: 364.84,
    y2: 139.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 378.27,
    x2: 422.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 426.78,
    x2: 491.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 100.72,
    y1: 139.28,
    x2: 491.92,
    y2: 139.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c70471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#134bb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 531.45,
    y1: 242.43,
    x2: 555.34,
    y2: 242.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#210294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134bb5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 545.22,
    y1: 218.55,
    x2: 560.23,
    y2: 218.55,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 684.1,
    y1: 56.36,
    x2: 704.92,
    y2: 56.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85037e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c70471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 570.34,
    y1: 249.84,
    x2: 577.85,
    y2: 249.84,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 721.83,
    y1: 64.65,
    x2: 737.47,
    y2: 64.65,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 713.16,
    y1: 44.52,
    x2: 720.66,
    y2: 44.52,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 538.2,
    y1: 115.8,
    x2: 715.37,
    y2: 115.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 532.32,
    y1: 137.69,
    x2: 721.64,
    y2: 137.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#210294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#134bb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c70471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 503.05,
    y1: 159.58,
    x2: 710.73,
    y2: 159.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#210294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#134bb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c70471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 722.9,
    y1: 88.83,
    x2: 730.4,
    y2: 88.83,
    xlinkHref: "#linear-gradient-10"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m146.06,157.03h-25.54l-6.15,18.67h-13.64l25.64-72.83h13.85l25.64,72.83h-13.64l-6.15-18.67Zm-12.82-41.54s-1.64,7.18-3.08,11.28l-6.46,19.49h19.08l-6.46-19.49c-1.33-4.1-2.87-11.28-2.87-11.28h-.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m174.67,160.11s5.74,5.74,14.26,5.74c3.69,0,6.87-1.64,6.87-4.72,0-7.8-25.44-6.77-25.44-23.59,0-9.74,8.72-15.39,20-15.39s17.54,5.95,17.54,5.95l-4.82,9.64s-4.82-4.51-12.82-4.51c-3.39,0-6.67,1.44-6.67,4.72,0,7.39,25.44,6.46,25.44,23.28,0,8.72-7.59,15.69-20,15.69-13.03,0-20.31-7.69-20.31-7.69l5.95-9.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m253.96,101.64c17.75,0,26.87,9.95,26.87,9.95l-6.36,9.85s-8.31-7.69-19.9-7.69c-15.39,0-24.41,11.49-24.41,25.03s9.33,26.05,24.52,26.05c12.62,0,21.13-9.23,21.13-9.23l6.98,9.54s-10.05,11.8-28.62,11.8c-22.26,0-37.64-16.52-37.64-37.95s16-37.34,37.44-37.34Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m327.19,101.64c21.44,0,37.64,16.31,37.64,37.13s-16.21,38.16-37.64,38.16-37.64-16.72-37.64-38.16,16.21-37.13,37.64-37.13Zm0,63.19c13.33,0,24-11.08,24-26.05s-10.67-25.03-24-25.03-24,10.67-24,25.03,10.67,26.05,24,26.05Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m378.27,102.87h13.23v61.44h31.49v11.39h-44.72v-72.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m472.12,157.03h-25.54l-6.15,18.67h-13.64l25.64-72.83h13.85l25.64,72.83h-13.64l-6.15-18.67Zm-12.82-41.54s-1.64,7.18-3.08,11.28l-6.46,19.49h19.08l-6.46-19.49c-1.33-4.1-2.87-11.28-2.87-11.28h-.21Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m146.06,157.03h-25.54l-6.15,18.67h-13.64l25.64-72.83h13.85l25.64,72.83h-13.64l-6.15-18.67Zm-12.82-41.54s-1.64,7.18-3.08,11.28l-6.46,19.49h19.08l-6.46-19.49c-1.33-4.1-2.87-11.28-2.87-11.28h-.21Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m174.67,160.11s5.74,5.74,14.26,5.74c3.69,0,6.87-1.64,6.87-4.72,0-7.8-25.44-6.77-25.44-23.59,0-9.74,8.72-15.39,20-15.39s17.54,5.95,17.54,5.95l-4.82,9.64s-4.82-4.51-12.82-4.51c-3.39,0-6.67,1.44-6.67,4.72,0,7.39,25.44,6.46,25.44,23.28,0,8.72-7.59,15.69-20,15.69-13.03,0-20.31-7.69-20.31-7.69l5.95-9.13Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m253.96,101.64c17.75,0,26.87,9.95,26.87,9.95l-6.36,9.85s-8.31-7.69-19.9-7.69c-15.39,0-24.41,11.49-24.41,25.03s9.33,26.05,24.52,26.05c12.62,0,21.13-9.23,21.13-9.23l6.98,9.54s-10.05,11.8-28.62,11.8c-22.26,0-37.64-16.52-37.64-37.95s16-37.34,37.44-37.34Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m327.19,101.64c21.44,0,37.64,16.31,37.64,37.13s-16.21,38.16-37.64,38.16-37.64-16.72-37.64-38.16,16.21-37.13,37.64-37.13Zm0,63.19c13.33,0,24-11.08,24-26.05s-10.67-25.03-24-25.03-24,10.67-24,25.03,10.67,26.05,24,26.05Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m378.27,102.87h13.23v61.44h31.49v11.39h-44.72v-72.83Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m472.12,157.03h-25.54l-6.15,18.67h-13.64l25.64-72.83h13.85l25.64,72.83h-13.64l-6.15-18.67Zm-12.82-41.54s-1.64,7.18-3.08,11.28l-6.46,19.49h19.08l-6.46-19.49c-1.33-4.1-2.87-11.28-2.87-11.28h-.21Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 531.45,
    y: 230.49,
    width: 23.88,
    height: 23.88,
    rx: 2.45,
    ry: 2.45
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 545.22,
    y: 211.04,
    width: 15.01,
    height: 15.01,
    rx: 2.45,
    ry: 2.45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 684.1,
    y: 45.95,
    width: 20.82,
    height: 20.82,
    rx: 2.45,
    ry: 2.45
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 570.34,
    y: 246.08,
    width: 7.5,
    height: 7.5,
    rx: 2.45,
    ry: 2.45
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 721.83,
    y: 56.83,
    width: 15.63,
    height: 15.63,
    rx: 2.45,
    ry: 2.45
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 713.16,
    y: 40.77,
    width: 7.5,
    height: 7.5,
    rx: 2.45,
    ry: 2.45
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m741.86,111.76c0-6.64-5.44-12.08-12.08-12.08h-35.52c-.9,0-1.58-.85-1.34-1.72,1.44-5.13,1.57-10.69,1.57-15.94,0-2.9.14-6.2-.18-9.37-.33-3.23-1.12-6.34-3.03-8.8-2.11-2.73-5.26-4.76-8.76-4.76-8.11,0-9.4,7.95-10.15,14.39-.88,7.52-1.23,15.29-4.55,22.21-2.33,4.85-5.62,9.01-10.8,11.06-3.98,1.57-6.9,2.79-11.09,3.61-.65.13-1.12.69-1.12,1.35v52.52c0,.76.62,1.38,1.38,1.38h14.53c.44,0,.85.22,1.11.57,2.87,3.84,7.45,6.33,12.61,6.33h45.53c6.64,0,12.08-5.44,12.08-12.08,0-1.72-.42-3.35-1.15-4.79-.29-.57-.14-1.27.36-1.67,2.46-1.96,4.05-6.44,4.05-9.82v-1.38c0-1.72-.42-3.35-1.15-4.79-.29-.57-.14-1.27.36-1.67,2.46-1.96,4.05-4.98,4.05-8.36v-1.38c0-1.72-.42-3.35-1.15-4.79-.29-.57-.14-1.27.36-1.67,2.46-1.96,4.05-4.98,4.05-8.36Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m636.31,104.42h-13.57s-.08-.02-.12-.02h-12.45c-.43,0-.78.35-.78.78v64.99c0,.43.35.78.78.78h.2s.08.02.12.02h25.82c.61,0,1.1-.49,1.1-1.1v-64.35c0-.61-.49-1.1-1.1-1.1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m600.61,109.77h-14.53c-.44,0-.85-.22-1.11-.57-2.87-3.84-7.45-6.33-12.61-6.33h-45.53c-6.64,0-12.08,5.44-12.08,12.08,0,1.72.42,3.35,1.15,4.79.29.57.14,1.27-.36,1.67-2.46,1.96-4.05,6.44-4.05,9.82v1.38c0,1.72.42,3.35,1.15,4.79.29.57.14,1.27-.36,1.67-2.46,1.96-4.05,4.98-4.05,8.36v1.38c0,1.72.42,3.35,1.15,4.79.29.57.14,1.27-.36,1.67-2.46,1.96-4.05,4.98-4.05,8.36,0,6.64,5.44,12.08,12.08,12.08h35.52c.9,0,1.58.85,1.34,1.72-1.44,5.13-1.57,10.69-1.57,15.94,0,2.9-.14,6.2.18,9.37.33,3.23,1.12,6.34,3.03,8.8,2.11,2.73,5.26,4.76,8.76,4.76,8.11,0,9.4-7.95,10.15-14.39.88-7.52,1.23-15.29,4.55-22.21,2.33-4.85,5.62-9.01,10.8-11.06,3.98-1.57,6.9-2.79,11.09-3.61.65-.13,1.12-.69,1.12-1.35v-52.52c0-.76-.62-1.38-1.38-1.38Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 743.32,
    y: 84.23,
    width: 15.63,
    height: 15.63,
    rx: 2.45,
    ry: 2.45
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 722.9,
    y: 85.08,
    width: 7.5,
    height: 7.5,
    rx: 2.45,
    ry: 2.45
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(100.1 198.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 10.53,
    y: 0
  }, "ssessi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 52.07,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 62.1,
    y: 0
  }, "g "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 76.02,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 86.31,
    y: 0
  }, "ou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 105.51,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 111.31,
    y: 0
  }, "ses of t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 162.28,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 172.32,
    y: 0
  }, "e Onli"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 215.22,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 225.25,
    y: 0
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 237.94,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 246.51,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 255.19,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 263.89,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 269.64,
    y: 0
  }, "ni"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 283.53,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 293.56,
    y: 0
  }, "g "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 307.48,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 318.01,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 328.15,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 333.82,
    y: 0
  }, "ee"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 351.64,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 367.44,
    y: 0
  }, "ent"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCollor);
export default __webpack_public_path__ + "static/media/logo_collor.c4e77e962784e41285eaf0a2c3784d4e.svg";
export { ForwardRef as ReactComponent };